import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./StudentReviews.css";

const reviews = [
  {
    name: " Dr. Ayesha Khan",
    course: " Fellowship Family Medicine",
    review:
    "Medby Academy helped me upgrade my medical skills with flexible online learning. The faculty is supportive, the content is well-structured, and I could study at my own pace. Highly recommend it for healthcare professionals looking to advance their careers.",
    rating: 5,
    image: "https://i.pinimg.com/736x/41/35/86/41358650e9b752f679b6d0464b55440f.jpg",
  },
  {
    name: "Rahul Singh",
    course: "Certificate Ultrasound Technician",
    review:
      "The classes are easy to follow, and I love how everything is online! I got my certificate on time, and the team guided me through every step. Medby Academy really cares about students.",
    rating: 4,
    image: "https://randomuser.me/api/portraits/men/7.jpg",
  },
  {
    name: "Dr. Meera Thomas",
    course: "Fellowship in Internal Medicine",
    review:
      "Medby Academy gave me the confidence and certification I needed to switch to a better job. The course material is up-to-date and industry-relevant. I’m grateful for their continuous support and mentoring.",
    rating: 5,
    image: "https://i.pinimg.com/736x/f2/36/20/f23620949430f856f6cbfadee7b47b97.jpg",
  },
  {
    name: "Preeti Chouhan",
    course: "Certificate Physician Assistant",
    review:
      "Learned so much in just 6 months! Thank you, Medby Academy, for making online medical education so accessible and affordable.",
    rating: 4,
    image: "https://i.pinimg.com/736x/29/d5/e8/29d5e8db75f3ed8fdbe7c47f097679dc.jpg",
  },
  {
    name: " Dr. Umesh",
    course: "Fetal Anomaly Scan",
    review:
      "Medby Academy connects healthcare professionals from all over. The learning experience is interactive, practical, and truly global. Great platform for continuous medical education.",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/65.jpg",
  },
];

const StudentReviews = () => {
  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="reviews-title"
        >
          What Our Students Say
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="reviews-subtitle"
        >
          Hear from learners who have transformed their careers with Medby Academy.
        </motion.p>

        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="reviews-slider"
        >
          {reviews.map((rev, index) => (
            <SwiperSlide key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="review-card"
              >
                <div className="review-header">
                  <img src={rev.image} alt={rev.name} className="review-img" />
                  <div>
                    <h4>{rev.name}</h4>
                    <p>{rev.course}</p>
                  </div>
                </div>
                <p className="review-text">“{rev.review}”</p>
                <div className="stars">
                  {[...Array(rev.rating)].map((_, i) => (
                    <Star key={i} size={18} fill="#FFD700" stroke="#FFD700" />
                  ))}
                </div>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default StudentReviews;
